import { helper } from '@ember/component/helper';

import attachToStrings from 'rise-ui/utils/attach-to-strings.js';
import { split } from 'rise-ui/utils/string.js';

const getDelimitedProps = (...props) => {
  const result = [];
  props.forEach(prop => {
    if (prop) {
      result.push(...split(prop, ' '));
    }
  });
  return result;
};

/**
 * @interface ClassModConfigConfig
 * @property {string} [class]
 * @property {string} [classes]
 * @property {string} [className]
 * @property {string} [classNames]
 * @property {string} [prefix]
 * @property {string} [suffix]
 * @property {string} [modifiers]
 */

/**
 * @interface ClassModConfigOptions
 * @implements ClassModConfigConfig
 * @property {ClassModConfigConfig} [config]
 */

/**
 * Outputs classes for combinations of given classNames and activated modifiers
 * @param {string|string[]} classNames
 * @param {array} modifiers Flat pairs of activation flag and modifier string
 *   it activates (e.g. [ true, '--enabled', false, '--disabled', ... ])
 * @param {ClassModConfigOptions} hash
 * @return {{classNames:string[],modifiers:string[]}|''}
 */
export default helper(function classModConfigHelper([ classNames, ...modifiers ], hash) {
  hash = hash || {};
  const config = hash.config || {};
  classNames = getDelimitedProps(
    classNames,
    hash.className || config.className || hash.classNames || config.classNames
    || hash.class || config.class || hash.classes || config.classes
  );
  if (!classNames.length) {
    return '';
  }
  const prefix = getDelimitedProps(hash.prefix, config.prefix).join('');
  const suffix = getDelimitedProps(hash.suffix, config.suffix).join('');
  if (prefix.length || suffix.length) {
    classNames = attachToStrings(classNames, { prefix, suffix, inclusive: false });
  }
  modifiers = [ ...modifiers, ...(config.modifiers || []) , ...(hash.modifiers || []) ];
  let result = [ ...classNames ];
  for (let i = 0; i + 1 < modifiers.length; i += 2) {
    if (modifiers[i]) {
      const mod = split(modifiers[i + 1], ' ');
      const mods = classNames.map(className =>
        mod.map(m => className.trim() + m.trim())
      );
      if (mods.length) {
        result.push(mods.join(' '));
      }
    }
  }
  return {
    classNames,
    modifiers,
  };
});
